if (!customElements.get('predictive-search-popup')) {
    customElements.define(
      'predictive-search-popup',
      class PredictiveSearchPopup extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('click', () => {
            this.openSearchPopup();
          });
          this.searchPopup = document.querySelector(".js-menu-popup-search");
          this.searchPopup.querySelector(".js-menu-close-search")?.addEventListener('click', this.closeSearchPopup.bind(this));
          this.searchOverlay = document.querySelector(".search-popup__overlay");
          if (this.searchOverlay) this.searchOverlay.addEventListener("click", this.closeSearchPopup.bind(this));
        }

        openSearchPopup() {
          if (!this.searchPopup) return;
          
          let body = document.body;
          let searchInput = this.searchPopup.querySelector(".js-search-input");
          
          document.querySelectorAll(".menu-popup--visible").forEach((active) => active.classList.remove("menu-popup--visible"));
          this.searchPopup.classList.add("menu-popup--visible");
          setTimeout(() => {
            searchInput.focus();
          }, 200);

          if (!body.classList.contains('search-open') && this.searchPopup.classList.contains('menu-popup--visible')) {
            body.classList.add('search-open');
            body.style.overflow = 'hidden';
            searchInput.removeAttribute("aria-hidden");
          }
        }

        closeSearchPopup() {
          let body = document.body;
          let searchInput = this.searchPopup.querySelector(".js-search-input");
          let menuPopup = searchInput.closest(".menu-popup");

          if (menuPopup.classList.contains("menu-popup--visible")) menuPopup.classList.remove("menu-popup--visible");
          body.classList.remove('search-open');
          body.style.overflow = '';
          searchInput.setAttribute("aria-hidden", true);
        }
      }
    );
}


class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this._productMarkup = '';
    this._collectionMarkup = '';
    this._sectionStatus = 'init';
    this._collectionCount = 0;
    this._productCount = 0;
    
    this.loadingWrapper = this.querySelectorAll('.js-loading-effect');
    this.input = this.querySelector('.js-search-input');
    this.onInputDebounced = this.debounce(this.onChange.bind(this), 300);
    this.input.addEventListener('input', this.onInputDebounced);

    this.handleQuickView();
    this.handleSearchPopupHeight();
    this.isMobile = window.matchMedia("(max-width: 900px)").matches;
    if(this.isMobile) this.handlePageNav();
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    this._productMarkup = '';
    this._collectionMarkup = '';
    this._collectionCount = 0;
    this._productCount = 0;
    this._sectionStatus = 'init';
    let searchTerm = this.getQuery();
    if (!searchTerm) return;
    this.getSearchResults(searchTerm, searchTerm.startsWith("collection:"));
    this.handleLoading(true);
  }

  getSearchResults(searchTerm, containCollection) {
    try { this.abortController.abort(); } catch(e) {}
    this.abortController = new AbortController();
   
    let originalTerm = searchTerm;
    if(containCollection) {
      searchTerm = searchTerm.replace("collection:", "").trim();
    }
    
    fetch(`${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection&resources[limit]=10&section_id=search`, { 
      signal: this.abortController.signal 
    })
    .then((response) => {
      if (!response.ok) throw new Error(response.status);
      return response.text();
    })
    .then((text) => {
      let html = new DOMParser().parseFromString(text, 'text/html');
      this.renderSearchResults(html, originalTerm, containCollection);
    })
    .catch((error) => {
      if (error?.code !== 20) console.error('Predictive search error:', error);
    })
    .finally(() => {
      if(containCollection) this.getSearchResults(originalTerm, false);
    });
  }

  renderSearchResults(html, originalTerm, containCollection) {
    let productSearchWrapper = !this.isMobile ? html?.querySelector('#main-search-wrapper') : html?.querySelector('.js-search-product-sec');
    let collectionSearchWrapper = !this.isMobile ? html?.querySelector('.js-collection-side') : html?.querySelector('.js-search-cards');
    let sectionWrapper = html?.querySelector('.js-menu-popup-search');

    let resultsMarkup = productSearchWrapper.innerHTML.trim() != '' ? productSearchWrapper.innerHTML.trim() : '';
    let collectionMarkup = collectionSearchWrapper.innerHTML.trim() != '' ? collectionSearchWrapper.innerHTML.trim() : '';
    let sectionStatus = sectionWrapper ? sectionWrapper.getAttribute('data-status') : 'empty';
    let prodCountWrapper = html.querySelector('.js-search-product-num');
    let prodCount = parseInt(prodCountWrapper.innerHTML) ? parseInt(prodCountWrapper.innerHTML) : 0; 
    let collectionCount = html.querySelector('.js-search-collection-num');
    
    if (!containCollection) {
      let productWrapper = !this.isMobile ? this.querySelector('#main-search-wrapper') : this.querySelector('.js-search-product-sec');
      if (productWrapper && resultsMarkup != '') {
        productWrapper.innerHTML = resultsMarkup;
      } 
      else if (productWrapper && this._productMarkup != '') {
        productWrapper.innerHTML = this._productMarkup;
      }

      let collectionWrapper = !this.isMobile ? this.querySelector('.js-collection-side') : this.querySelector('.js-search-cards');
      if (collectionWrapper && this._collectionMarkup != '' && originalTerm.startsWith("collection:")) {
        collectionWrapper.innerHTML = this._collectionMarkup;
      }
      else if (collectionWrapper && collectionMarkup != '') {
        collectionWrapper.innerHTML = collectionMarkup;
      }

      if(this.isMobile) {
        if(collectionCount && this._productCount != 0 && prodCount == 0 && originalTerm.startsWith("collection:")) {
          this.querySelector('.js-search-product-num').innerHTML = this._productCount;
        } 
        else if (prodCountWrapper) {
          this.querySelector('.js-search-product-num').innerHTML = prodCountWrapper.innerHTML.trim();
        }
        if (collectionCount && this._collectionCount != 0 && originalTerm.startsWith("collection:")) {
          this.querySelector('.js-search-collection-num').innerHTML = this._collectionCount;
        }
        else if (collectionCount) {
          this.querySelector('.js-search-collection-num').innerHTML = collectionCount.innerHTML;
        }
      }
      
      if (
        originalTerm != '' &&
        sectionStatus == 'empty' &&
        (!originalTerm.startsWith("collection:") || (originalTerm.startsWith("collection:") && this._sectionStatus != 'init'))
      ) {
        this.querySelector('.js-search-term').innerHTML = originalTerm;
        this.closest('.js-menu-popup-search')?.setAttribute('data-status', 'empty');
      }
      else {
        this.closest('.js-menu-popup-search')?.setAttribute('data-status', this.isMobile ? 'results' : 'init');
      }
    }
    this._productMarkup = resultsMarkup;
    this._collectionMarkup = collectionMarkup;
    this._collectionCount = parseInt(collectionCount.innerHTML) || 0;
    this._productCount = prodCount;
    this._sectionStatus = sectionStatus;
    this.handleQuickView();
    this.handleSearchPopupHeight();
    this.handleLoading(false);
  }

  handleSearchPopupHeight() {
    let productUnits = this.querySelectorAll('.js-product-card');
    this.classList.toggle('search-popup--scroll', productUnits.length > 4);
  }

  handleQuickView() {
    let productUnits = this.querySelectorAll('.js-product-card');
    if (productUnits.length > 0) {
      productUnits.forEach((prodUnit) => {
        let link = prodUnit.querySelector('.quick-view__link');
        link.addEventListener("click", calpak.quickViewClick);
      })
    }
  }

  handlePageNav() {
    let pageNavBtns = this.querySelectorAll('.js-search-category-btn');
    let navWrapper = this.querySelector('.js-mobile-page-nav');
    if(pageNavBtns.length > 0) {
      pageNavBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          let btnTarget = btn.getAttribute('data-target');
          navWrapper.setAttribute('data-page', btnTarget);
        });
      });
    }
  }

  handleLoading(load) {
    this.loadingWrapper.forEach(wrap => wrap.classList.toggle('is-loading', load));
  }

  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);

class CollectionSearchBtns extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll('.js-collection-button');
    if (!this.buttons.length > 0) return;
    this.buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        let host = this.closest('predictive-search');
        if (!host || !host.input) return;
        host.input.value = `collection:${button.dataset.handle}`;
        host.onChange();
      });
    })
  }
}

customElements.define('collection-search-btns', CollectionSearchBtns);

document.addEventListener('DOMContentLoaded', () => {
  let tabs = document.querySelectorAll('.js-srch-tab');
  let panels = document.querySelectorAll('.js-srch-tab-panel');

  if(!tabs.length && !panels.length) return;
  
  function activateTab(tabName) {
    tabs.forEach(btn => {
      let active = btn.dataset.tab === tabName;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active);
    });

    panels.forEach(panel => {
      panel.classList.toggle('is-active', panel.id === `tab-panel-${tabName}`);
    });
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      let name = tab.dataset.tab;
      activateTab(name);
    });
  });
});

